import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants';




/*

Props:
 ...constants.layout.sectionTopBottomMargins,
        ...constants.layout.contentWidth,
        maxWidth: constants.layout.contentWidth.maxWidth - 20, 

*/

const StyledDiv = styled.div`
    @keyframes animateDown {
    0%   {margin-top: -100px; clip-path: inset(100% 0px 0px 0px);}
    100% {margin-top: 0px; clip-path: inset(0px 0px 0px 0px);}
    }   

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: white;
    padding: 15px 0px 20px 0px;
    border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
    border-right: 1px rgba(0, 0, 0, 0.1) solid;
    border-left: 1px rgba(0, 0, 0, 0.1) solid;
    animation-name: animateDown;
    animation-duration: 0.3s;
    border-radius: 0px 0px 5px 5px;
    max-width: ${constants.layout.contentWidth.maxWidth - 20}px;
    align-self: center;
    width: 90%;

    @media (max-width: ${props => (props.mediaQ1) ? props.mediaQ1 : '0'}px){

    }
`;


const OuterContainerSC = ({ styles, onClick, children, ...rest }) => (
    <StyledDiv style = {styles}  onClick = {onClick} {...rest} >
        { children }
    </StyledDiv>
)



export default OuterContainerSC

// color: ${props => (props.color) ? props.color : 'red'};
//   box-shadow: -7px 11px 78px -24px rgba(0,0,0,0.16);


// WEBPACK FOOTER //
// ./src/js/components/Search/OuterContainerSC.jsx